import React, { useEffect } from 'react';
import WOW from 'wowjs';
import translate from '../translate';
import { useSelector } from 'react-redux'; // Added useSelector import

function Brand() {
    const language = useSelector((state) => state.view.selectedLanguage); // Defined language variable
    const componentName = 'brand'; // Defined componentName variable

    useEffect(() => {
        const wow = new WOW.WOW({
            live: false,
            offset: 100,
            mobile: true,
        });
        wow.init();
    }, []);

    return (
        <div className="brand-section pt-125 pb-130">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-6">
                    <div className="section-heading text-center mb-60">
                        <span className="sub-heading">{translate(componentName, 'subHeading', language)}</span> {/* Updated function call */}
                        <h2 className="heading">{translate(componentName, 'heading', language)}</h2> {/* Updated function call */}
                    </div>
                </div>
            </div>
            <div className="row justify-content-center mt-none-30">
                <div className="col-xl-3 col-lg-4 col-md-6 mt-30">
                    <div className="brand-box brand-box__1 wow fadeInUp" data-wow-delay="0ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/brand-icon-1.png" alt=""/>
                        </div>
                        <div className="content">
                            <h6 className="title">{translate(componentName, 'industry1', language)}</h6> {/* Updated function call */}
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mt-30">
                    <div className="brand-box brand-box__2 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/brand-icon-2.png" alt=""/>
                        </div>
                        <div className="content">
                            <h6 className="title">{translate(componentName, 'industry2', language)}</h6> {/* Updated function call */}
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mt-30">
                    <div className="brand-box brand-box__3 wow fadeInUp" data-wow-delay="300ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/brand-icon-3.png" alt=""/>
                        </div>
                        <div className="content">
                            <h6 className="title">{translate(componentName, 'industry3', language)}</h6> {/* Updated function call */}
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mt-30">
                    <div className="brand-box brand-box__4 wow fadeInUp" data-wow-delay="400ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/brand-icon-4.png" alt=""/>
                        </div>
                        <div className="content">
                            <h6 className="title">{translate(componentName, 'industry4', language)}</h6> {/* Updated function call */}
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mt-30">
                    <div className="brand-box brand-box__5 wow fadeInUp" data-wow-delay="500ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/brand-icon-5.png" alt=""/>
                        </div>
                        <div className="content">
                            <h6 className="title">{translate(componentName, 'industry5', language)}</h6> {/* Updated function call */}
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mt-30">
                    <div className="brand-box brand-box__6 wow fadeInUp" data-wow-delay="600ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/brand-icon-6.png" alt=""/>
                        </div>
                        <div className="content">
                            <h6 className="title">{translate(componentName, 'industry6', language)}</h6> {/* Updated function call */}
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mt-30">
                    <div className="brand-box brand-box__7 wow fadeInUp" data-wow-delay="700ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/brand-icon-7.png" alt=""/>
                        </div>
                        <div className="content">
                            <h6 className="title">{translate(componentName, 'industry7', language)}</h6> {/* Updated function call */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Brand;